import { isEmpty } from 'ramda'
import { createSelector } from 'reselect'
import { selectEasymsOrganizationsKV } from '../easymsOrganizationSelector'

const getCurrentOrganization = state => state.bookingCurrentOrganization
const getOrganizations = state => state.bookingOrganizations

export const selectCurrentOrganization = createSelector(
    getCurrentOrganization,
    currentOrganization => currentOrganization || ''
)

/**
 * Створює унікальний список організацій з нормалізованої структури
 * @param {Object} organizations - Нормалізовані дані організацій
 * @returns {Array} Масив унікальних організацій
 */
const getUniqueOrganizations = organizations => {
    const { entities, result } = organizations

    if (isEmpty(entities) || isEmpty(result)) {
        return []
    }

    const items = entities.organizations
    const list = result.map(id => items[id])

    // Створюємо Map для видалення дублікатів по ourId
    const uniqueMap = new Map()
    list.forEach(item => {
        if (!uniqueMap.has(item.ourId)) {
            uniqueMap.set(item.ourId, item)
        }
    })

    return Array.from(uniqueMap.values())
}

/**
 * Видаляє текст в дужках з кінця рядка
 * @param {string} text - Вхідний текст
 * @returns {string} Текст без дужок в кінці
 */
const removeTrailingParentheses = text => {
    return text.replace(/\([^()]*\)\s*$/, '').trim()
}

/**
 * Збагачує організацію даними з EasyMS
 * @param {Object} org - Організація
 * @param {Array} easymsOrganizationsKV - Список організацій EasyMS
 * @returns {Object} Організація з додатковим полем ourName
 */
const enrichOrganization = (org, easymsOrganizationsKV) => {
    const match = easymsOrganizationsKV.find(opt => opt.value === org.ourId)

    if (!match) {
        return {
            ...org,
            ourName: null
        }
    }

    const ourName = removeTrailingParentheses(match.label)

    return {
        ...org,
        ourName
    }
}

/**
 * Селектор для отримання списку організацій зі збагаченими даними
 * Об'єднує дані з booking організацій та EasyMS організацій
 */
export const selectOrganizationList = createSelector(
    [getOrganizations, selectEasymsOrganizationsKV],
    (organizations, easymsOrganizationsKV) => {
        const uniqueOrganizations = getUniqueOrganizations(organizations)

        if (uniqueOrganizations.length === 0) {
            return []
        }

        if (isEmpty(easymsOrganizationsKV)) {
            return uniqueOrganizations.map(org => ({
                ...org,
                ourName: null
            }))
        }

        return uniqueOrganizations.map(org => enrichOrganization(org, easymsOrganizationsKV))
    }
)



// WEBPACK FOOTER //
// ./src/selectors/bookingSelectors/bookingCurrentOrganization.js